import { Handle, Position } from 'reactflow';

export  const DamNode = ({ data }: { data: { label: string; onDelete: () => void, is_client_flow?: boolean} }) => {
  
  return (
    <div
      className="group relative flex flex-col items-center justify-center w-10 h-20 border"
      style={{ borderColor: 'black', backgroundColor: '#32CD32' }}
    >
      <span className="text-sm font-bold text-white"></span>

      <Handle type="source" position={Position.Bottom} className="w-2 h-2 opacity-0 group-hover:opacity-75" style={{ backgroundColor: '#FF4500' }} />
          <Handle type="target" position={Position.Top} className="w-2 h-2 opacity-0 group-hover:opacity-75" style={{ backgroundColor: '#FF4500' }} />
      {!data.is_client_flow && (
        <>
          
          <button
        className="absolute top-0 right-0 hidden bg-white p-1 text-red-600 transition-all ease-in-out hover:bg-red-500 hover:text-red-200 group-hover:block dark:text-white"
        onClick={() => data.onDelete()}
          >
        <svg className="h-1 w-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
          </button>
        </>
      )}
    </div>
  );
};
